import React from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';
import Page from '../components/Page';

// STYLES
const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0%;
`;

const ListItem = styled.li`
  margin-bottom: 1.2rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ListLink = styled.a`
  text-decoration: none;
  font-weight: bold;
  transition: all 0.2s;
  display: inline-block;
  line-height: 1.2;

  &:hover {
    color: ${props => props.theme.color.secondary};
    text-decoration: none;
  }
`;

const Image = styled.img`
  max-width: 344px;
`;


// COMPONENT
const Hoerproben = props => {
  
  const { data } = props;

  return (
    <Page title="Hörproben">
      <Row middle="sm">
        <Col xs={12} sm={6}>
          <Image src={ process.env.REACT_APP_ROOT + data.image.path } alt="" />
        </Col>
        <Col xs={12} sm={6}>
          <List>
            { data.samples.map(sample => (
              <ListItem><ListLink key={ sample.value.file } href={ process.env.REACT_APP_ROOT + '/' + sample.value.file } target="_blank" rel="noopener noreferrer">{ sample.value.label }</ListLink></ListItem>
            )) }
          </List>
        </Col>
      </Row>
    </Page>
  );
};

export default Hoerproben;